export const THEME_PRESETS = {
  default: {
    id: 'default',
    theme: 'light',
    appearance: 'default',
    vars: {
      '--body-bg': 'linear-gradient(135deg, #f5f7fa 0%, #ffffff 50%, #f8f9fa 100%)',
      '--app-bg': '#f3f6fb',
      '--content-bg': '#f3f6fb',
      '--navbar-bg': 'linear-gradient(180deg, #ffffff 0%, #fafbfc 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #fafbfc 100%)',
      '--mail-list-bg': '#ffffff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#ffffff',
      '--surface-muted': '#f8f9fa',
      '--accent': '#667eea',
      '--accent-2': '#764ba2',
      '--accent-soft': '#e8f0fe',
      '--text-primary': '#202124',
      '--border-color': 'rgba(218, 220, 224, 0.5)',
    },
  },
  dark: {
    id: 'dark',
    theme: 'dark',
    appearance: 'default',
    vars: {
      '--body-bg': '#0f172a',
      '--app-bg': '#0f172a',
      '--content-bg': '#111827',
      '--navbar-bg': 'linear-gradient(135deg, rgba(15, 23, 42, 0.92), rgba(15, 23, 42, 0.8))',
      '--sidebar-bg': '#111827',
      '--inbox-bg': '#111827',
      '--mail-list-bg': '#111827',
      '--mail-detail-bg': '#111827',
      '--toolbar-bg': '#1f2937',
      '--surface-muted': '#1f2937',
      '--accent': '#60a5fa',
      '--accent-2': '#3b82f6',
      '--accent-soft': '#1e3a5f',
      '--text-primary': '#e5e7eb',
      '--border-color': 'rgba(55, 65, 81, 0.9)',
    },
  },
  ocean: {
    id: 'ocean',
    theme: 'light',
    appearance: 'ocean',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #e0f2fe 0%, #f0f9ff 50%, #f8fafc 100%)',
      '--app-bg': '#e0f2fe',
      '--content-bg': 'linear-gradient(160deg, #e0f2fe 0%, #f0f9ff 45%, #f8fafc 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f0f9ff 100%)',
      '--mail-list-bg': '#f8fdff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#f0f9ff',
      '--surface-muted': '#e0f2fe',
      '--accent': '#0284c7',
      '--accent-2': '#0ea5e9',
      '--accent-soft': '#bae6fd',
      '--text-primary': '#0c4a6e',
      '--border-color': 'rgba(14, 165, 233, 0.25)',
    },
  },
  sunset: {
    id: 'sunset',
    theme: 'light',
    appearance: 'sunset',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #fff7ed 0%, #ffedd5 50%, #fffbeb 100%)',
      '--app-bg': '#fff7ed',
      '--content-bg': 'linear-gradient(160deg, #fff7ed 0%, #ffedd5 50%, #fffbeb 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #fff7ed 100%)',
      '--mail-list-bg': '#fffaf5',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#ffedd5',
      '--surface-muted': '#fed7aa',
      '--accent': '#ea580c',
      '--accent-2': '#f97316',
      '--accent-soft': '#ffedd5',
      '--text-primary': '#7c2d12',
      '--border-color': 'rgba(249, 115, 22, 0.25)',
    },
  },
  forest: {
    id: 'forest',
    theme: 'light',
    appearance: 'forest',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #ecfdf5 0%, #d1fae5 50%, #f0fdf4 100%)',
      '--app-bg': '#ecfdf5',
      '--content-bg': 'linear-gradient(160deg, #ecfdf5 0%, #d1fae5 50%, #f0fdf4 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #ecfdf5 0%, #d1fae5 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #ecfdf5 100%)',
      '--mail-list-bg': '#f7fef9',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#d1fae5',
      '--surface-muted': '#bbf7d0',
      '--accent': '#059669',
      '--accent-2': '#10b981',
      '--accent-soft': '#d1fae5',
      '--text-primary': '#14532d',
      '--border-color': 'rgba(16, 185, 129, 0.25)',
    },
  },
  lavender: {
    id: 'lavender',
    theme: 'light',
    appearance: 'lavender',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #f5f3ff 0%, #ede9fe 50%, #faf5ff 100%)',
      '--app-bg': '#f5f3ff',
      '--content-bg': 'linear-gradient(160deg, #f5f3ff 0%, #ede9fe 50%, #faf5ff 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f5f3ff 0%, #ede9fe 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f5f3ff 0%, #ede9fe 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f5f3ff 100%)',
      '--mail-list-bg': '#faf8ff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#ede9fe',
      '--surface-muted': '#ddd6fe',
      '--accent': '#7c3aed',
      '--accent-2': '#8b5cf6',
      '--accent-soft': '#ede9fe',
      '--text-primary': '#4c1d95',
      '--border-color': 'rgba(139, 92, 246, 0.25)',
    },
  },
  slate: {
    id: 'slate',
    theme: 'light',
    appearance: 'slate',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #f1f5f9 0%, #e2e8f0 50%, #f8fafc 100%)',
      '--app-bg': '#f1f5f9',
      '--content-bg': 'linear-gradient(160deg, #f1f5f9 0%, #e2e8f0 50%, #f8fafc 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%)',
      '--mail-list-bg': '#f8fafc',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#e2e8f0',
      '--surface-muted': '#cbd5e1',
      '--accent': '#475569',
      '--accent-2': '#64748b',
      '--accent-soft': '#e2e8f0',
      '--text-primary': '#1e293b',
      '--border-color': 'rgba(100, 116, 139, 0.3)',
    },
  },
  warm: {
    id: 'warm',
    theme: 'light',
    appearance: 'warm',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #fef2f2 0%, #fee2e2 50%, #fff7ed 100%)',
      '--app-bg': '#fef2f2',
      '--content-bg': 'linear-gradient(160deg, #fef2f2 0%, #fee2e2 50%, #fff7ed 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #fef2f2 0%, #fee2e2 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #fef2f2 0%, #fee2e2 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #fef2f2 100%)',
      '--mail-list-bg': '#fffaf9',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#fee2e2',
      '--surface-muted': '#fecaca',
      '--accent': '#dc2626',
      '--accent-2': '#f87171',
      '--accent-soft': '#fee2e2',
      '--text-primary': '#7f1d1d',
      '--border-color': 'rgba(248, 113, 113, 0.3)',
    },
  },
  bokeh: {
    id: 'bokeh',
    theme: 'light',
    appearance: 'bokeh',
    vars: {
      '--body-bg': 'linear-gradient(135deg, #fce7f3 0%, #e0e7ff 40%, #cffafe 100%)',
      '--app-bg': '#f5f3ff',
      '--content-bg': 'linear-gradient(135deg, #fce7f3 0%, #e0e7ff 50%, #ecfeff 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #faf5ff 0%, #ede9fe 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #faf5ff 0%, #e0e7ff 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f5f3ff 100%)',
      '--mail-list-bg': '#ffffff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#ede9fe',
      '--surface-muted': '#e0e7ff',
      '--accent': '#a855f7',
      '--accent-2': '#ec4899',
      '--accent-soft': '#f3e8ff',
      '--text-primary': '#4c1d95',
      '--border-color': 'rgba(168, 85, 247, 0.25)',
    },
  },
  canyon: {
    id: 'canyon',
    theme: 'light',
    appearance: 'canyon',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #fed7aa 0%, #fdba74 50%, #fef3c7 100%)',
      '--app-bg': '#ffedd5',
      '--content-bg': 'linear-gradient(160deg, #fed7aa 0%, #fdba74 50%, #fff7ed 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #fff7ed 0%, #fed7aa 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #ffedd5 100%)',
      '--mail-list-bg': '#fffaf5',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#fed7aa',
      '--surface-muted': '#fdba74',
      '--accent': '#c2410c',
      '--accent-2': '#ea580c',
      '--accent-soft': '#ffedd5',
      '--text-primary': '#7c2d12',
      '--border-color': 'rgba(234, 88, 12, 0.3)',
    },
  },
  chess: {
    id: 'chess',
    theme: 'light',
    appearance: 'chess',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #f4f4f5 0%, #e4e4e7 50%, #fafafa 100%)',
      '--app-bg': '#f4f4f5',
      '--content-bg': 'linear-gradient(160deg, #f4f4f5 0%, #e4e4e7 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #ffffff 0%, #f4f4f5 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #ffffff 0%, #f4f4f5 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #fafafa 100%)',
      '--mail-list-bg': '#ffffff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#f4f4f5',
      '--surface-muted': '#e4e4e7',
      '--accent': '#18181b',
      '--accent-2': '#3f3f46',
      '--accent-soft': '#e4e4e7',
      '--text-primary': '#18181b',
      '--border-color': 'rgba(63, 63, 70, 0.25)',
    },
  },
  beach: {
    id: 'beach',
    theme: 'light',
    appearance: 'beach',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #bae6fd 0%, #7dd3fc 40%, #fef9c3 100%)',
      '--app-bg': '#e0f2fe',
      '--content-bg': 'linear-gradient(160deg, #bae6fd 0%, #7dd3fc 50%, #fefce8 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f0f9ff 0%, #bae6fd 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f0f9ff 100%)',
      '--mail-list-bg': '#f8fdff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#bae6fd',
      '--surface-muted': '#7dd3fc',
      '--accent': '#0369a1',
      '--accent-2': '#0ea5e9',
      '--accent-soft': '#e0f2fe',
      '--text-primary': '#0c4a6e',
      '--border-color': 'rgba(14, 165, 233, 0.3)',
    },
  },
  mountains: {
    id: 'mountains',
    theme: 'light',
    appearance: 'mountains',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #cbd5e1 0%, #94a3b8 50%, #e2e8f0 100%)',
      '--app-bg': '#e2e8f0',
      '--content-bg': 'linear-gradient(160deg, #cbd5e1 0%, #94a3b8 50%, #f1f5f9 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f8fafc 0%, #cbd5e1 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%)',
      '--mail-list-bg': '#ffffff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#cbd5e1',
      '--surface-muted': '#94a3b8',
      '--accent': '#334155',
      '--accent-2': '#475569',
      '--accent-soft': '#e2e8f0',
      '--text-primary': '#1e293b',
      '--border-color': 'rgba(71, 85, 105, 0.3)',
    },
  },
  aurora: {
    id: 'aurora',
    theme: 'light',
    appearance: 'aurora',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #312e81 0%, #4c1d95 40%, #0f766e 100%)',
      '--app-bg': '#1e1b4b',
      '--content-bg': 'linear-gradient(160deg, #312e81 0%, #4c1d95 50%, #134e4a 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #312e81 0%, #1e1b4b 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #312e81 0%, #1e1b4b 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #3730a3 0%, #1e1b4b 100%)',
      '--mail-list-bg': '#312e81',
      '--mail-detail-bg': '#3730a3',
      '--toolbar-bg': '#4c1d95',
      '--surface-muted': '#4338ca',
      '--accent': '#22d3ee',
      '--accent-2': '#a78bfa',
      '--accent-soft': '#4338ca',
      '--text-primary': '#e0e7ff',
      '--border-color': 'rgba(167, 139, 250, 0.35)',
    },
  },
  desert: {
    id: 'desert',
    theme: 'light',
    appearance: 'desert',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #fde68a 0%, #fcd34d 50%, #fef3c7 100%)',
      '--app-bg': '#fef3c7',
      '--content-bg': 'linear-gradient(160deg, #fde68a 0%, #fcd34d 50%, #fffbeb 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #fffbeb 0%, #fef3c7 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #fffbeb 0%, #fde68a 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #fffbeb 100%)',
      '--mail-list-bg': '#fffef8',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#fde68a',
      '--surface-muted': '#fcd34d',
      '--accent': '#b45309',
      '--accent-2': '#d97706',
      '--accent-soft': '#fef3c7',
      '--text-primary': '#78350f',
      '--border-color': 'rgba(217, 119, 6, 0.3)',
    },
  },
  garden: {
    id: 'garden',
    theme: 'light',
    appearance: 'garden',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #bbf7d0 0%, #86efac 50%, #fef9c3 100%)',
      '--app-bg': '#ecfccb',
      '--content-bg': 'linear-gradient(160deg, #bbf7d0 0%, #86efac 50%, #f7fee7 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f7fee7 0%, #ecfccb 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f7fee7 0%, #d9f99d 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f7fee7 100%)',
      '--mail-list-bg': '#fefff8',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#bbf7d0',
      '--surface-muted': '#86efac',
      '--accent': '#15803d',
      '--accent-2': '#22c55e',
      '--accent-soft': '#dcfce7',
      '--text-primary': '#14532d',
      '--border-color': 'rgba(34, 197, 94, 0.3)',
    },
  },
  lake: {
    id: 'lake',
    theme: 'light',
    appearance: 'lake',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #99f6e4 0%, #5eead4 50%, #ccfbf1 100%)',
      '--app-bg': '#ccfbf1',
      '--content-bg': 'linear-gradient(160deg, #99f6e4 0%, #5eead4 50%, #f0fdfa 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #f0fdfa 0%, #ccfbf1 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #f0fdfa 0%, #99f6e4 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f0fdfa 100%)',
      '--mail-list-bg': '#f8fffe',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#99f6e4',
      '--surface-muted': '#5eead4',
      '--accent': '#0f766e',
      '--accent-2': '#14b8a6',
      '--accent-soft': '#ccfbf1',
      '--text-primary': '#134e4a',
      '--border-color': 'rgba(20, 184, 166, 0.3)',
    },
  },
  city: {
    id: 'city',
    theme: 'light',
    appearance: 'city',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #1e293b 0%, #334155 50%, #64748b 100%)',
      '--app-bg': '#1e293b',
      '--content-bg': 'linear-gradient(160deg, #1e293b 0%, #334155 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #334155 0%, #1e293b 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #334155 0%, #1e293b 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #334155 0%, #1e293b 100%)',
      '--mail-list-bg': '#1e293b',
      '--mail-detail-bg': '#334155',
      '--toolbar-bg': '#334155',
      '--surface-muted': '#475569',
      '--accent': '#38bdf8',
      '--accent-2': '#60a5fa',
      '--accent-soft': '#334155',
      '--text-primary': '#e2e8f0',
      '--border-color': 'rgba(148, 163, 184, 0.35)',
    },
  },
  autumn: {
    id: 'autumn',
    theme: 'light',
    appearance: 'autumn',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #fdba74 0%, #f97316 40%, #854d0e 100%)',
      '--app-bg': '#ffedd5',
      '--content-bg': 'linear-gradient(160deg, #fed7aa 0%, #fdba74 50%, #fef3c7 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #fff7ed 0%, #fed7aa 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #fff7ed 100%)',
      '--mail-list-bg': '#fffaf5',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#fdba74',
      '--surface-muted': '#fb923c',
      '--accent': '#9a3412',
      '--accent-2': '#c2410c',
      '--accent-soft': '#ffedd5',
      '--text-primary': '#431407',
      '--border-color': 'rgba(194, 65, 12, 0.3)',
    },
  },
  marble: {
    id: 'marble',
    theme: 'light',
    appearance: 'marble',
    vars: {
      '--body-bg': 'linear-gradient(160deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
      '--app-bg': '#f8fafc',
      '--content-bg': 'linear-gradient(160deg, #ffffff 0%, #f1f5f9 100%)',
      '--navbar-bg': 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
      '--sidebar-bg': 'linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%)',
      '--inbox-bg': 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
      '--mail-list-bg': '#ffffff',
      '--mail-detail-bg': '#ffffff',
      '--toolbar-bg': '#f1f5f9',
      '--surface-muted': '#e2e8f0',
      '--accent': '#64748b',
      '--accent-2': '#94a3b8',
      '--accent-soft': '#f1f5f9',
      '--text-primary': '#334155',
      '--border-color': 'rgba(148, 163, 184, 0.35)',
    },
  },
};

export const QUICK_THEME_IDS = ['default', 'dark', 'ocean', 'sunset', 'forest', 'lavender', 'slate', 'warm'];

export const presetToThemeOption = (preset) => ({
  id: preset.id,
  theme: preset.theme,
  appearance: preset.appearance,
  className: `wallpaper-${preset.id}`,
});

export const getAllThemeOptions = () =>
  Object.values(THEME_PRESETS).map(presetToThemeOption);

export const getQuickThemeOptions = () =>
  QUICK_THEME_IDS.filter((id) => THEME_PRESETS[id]).map((id) => presetToThemeOption(THEME_PRESETS[id]));

export const defaultMailSettings = {
  density: 'default',
  theme: 'light',
  appearance: 'default',
  themeId: 'default',
  inboxType: 'default',
  readingPane: 'no-split',
};

export const resolveThemePreset = (settings) => {
  if (settings?.themeId && THEME_PRESETS[settings.themeId]) {
    return THEME_PRESETS[settings.themeId];
  }

  const match = Object.values(THEME_PRESETS).find(
    (preset) =>
      preset.theme === (settings?.theme || 'light') &&
      preset.appearance === (settings?.appearance || 'default')
  );

  return match || THEME_PRESETS.default;
};

export const getMailSettings = () => {
  try {
    const saved = JSON.parse(localStorage.getItem('mailSettings') || '{}');
    const merged = { ...defaultMailSettings, ...saved };
    const preset = resolveThemePreset(merged);
    return {
      ...merged,
      theme: preset.theme,
      appearance: preset.appearance,
      themeId: preset.id,
    };
  } catch (_error) {
    return defaultMailSettings;
  }
};

export const saveMailSettings = (settings) => {
  localStorage.setItem('mailSettings', JSON.stringify(settings));
  window.dispatchEvent(new CustomEvent('mailSettingsChanged', { detail: settings }));
};

/* ------------------------------------------------- workspace accent contrast */

const HEX_COLOR = /^#?([\da-f]{3}|[\da-f]{6})$/i;

const toRgb = (value) => {
  const match = String(value || '').trim().match(HEX_COLOR);
  if (!match) return null;
  const hex = match[1].length === 3 ? match[1].replace(/./g, (c) => c + c) : match[1];
  return [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
};

const toHex = (rgb) =>
  `#${rgb
    .map((c) => Math.round(Math.min(Math.max(c, 0), 255)).toString(16).padStart(2, '0'))
    .join('')}`;

/** WCAG relative luminance, used to judge contrast against the page colour. */
const luminance = ([r, g, b]) => {
  const channel = (c) => {
    const v = c / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
};

const mix = (from, to, weight) => from.map((c, i) => c + (to[i] - c) * weight);

const WHITE = [255, 255, 255];
const DARK_PANEL = [17, 24, 39];

/**
 * Derive the accent pair the workspace modules paint with.
 *
 * The presets choose their accent to sit on their own tinted mail chrome, but
 * the workspace pages are plain white (near-black in dark mode). Several presets
 * are also flagged `light` while shipping a dark palette — `aurora` pairs a
 * #22d3ee accent with a #4338ca "soft" fill — so using the raw values would put
 * a dark block and an unreadable cyan label on a white page.
 *
 * `--ws-accent` is therefore pushed toward the page's opposite end until it
 * clears the 4.5:1 text threshold, and `--ws-accent-soft` is always built as a
 * tint of the page colour so it can never come out dark in a light theme.
 */
const workspaceAccentVars = (preset) => {
  const isDark = preset.theme === 'dark';
  const page = isDark ? DARK_PANEL : WHITE;
  const pull = isDark ? WHITE : [0, 0, 0];
  // Luminance needed for 4.5:1 against the page colour.
  const needs = (rgb) => (isDark ? luminance(rgb) < 0.22 : luminance(rgb) > 0.18);

  let accent = toRgb(preset.vars['--accent']) || [102, 126, 234];
  for (let step = 0; step < 12 && needs(accent); step += 1) {
    accent = mix(accent, pull, 0.16);
  }

  return {
    '--ws-accent': toHex(accent),
    '--ws-accent-alt': toHex(mix(accent, pull, 0.18)),
    '--ws-accent-soft': toHex(mix(page, accent, isDark ? 0.26 : 0.12)),
  };
};

export const applyMailSettings = (settings) => {
  const preset = resolveThemePreset(settings);
  const applied = {
    ...settings,
    theme: preset.theme,
    appearance: preset.appearance,
    themeId: preset.id,
  };

  document.body.dataset.theme = preset.theme;
  document.body.dataset.appearance = preset.appearance;
  document.body.dataset.density = applied.density || 'default';
  document.body.dataset.inboxType = applied.inboxType || 'default';
  document.body.dataset.readingPane = applied.readingPane || 'no-split';

  const root = document.documentElement;
  Object.entries({ ...preset.vars, ...workspaceAccentVars(preset) }).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  return applied;
};
